<template>
	<GmapInfoWindow class="multiple-video-container"
        :options="{
          pixelOffset: { width: 0, height: -15 }
        }"
				v-if="tryingConnection">
			<VideoElementMultiple
				v-if="socket && inProgress"
				:remoteCalledStream="remoteCalledStream"
				:loadingRemote="loadingRemote"
				:timerConnectionInterval="timerConnectionInterval"
				:closePreview="closePreview"
				:startVideoCall="goToFullVideoCall"
				:videoCallData="videoCallData"
			/>
	</GmapInfoWindow>
</template>

<script>
	import * as firebase from 'firebase/app'
	import 'firebase/database'
	import {startAtencion, endAtencion} from '../../api/atenciones'
	import kurentoUtils from 'kurento-utils'
	import io from 'socket.io-client'
  import {createVideoCallRoom,initVideoCallWithDevice} from '../../api/atenciones'
	import VideoElementMultiple from './VideoElementMultiple'

	export default {
	  name: 'VideoCallRoom',
		components: {VideoElementMultiple},
    props: {
      videoCallData: {
        type: Object,
				required: true
      }
    },
	  data(){
	    return {
	    	fullView: true,
	    	inProgress: false,
	    	localWebRtcPeer: null,
	    	localStream: null,
	    	remotesWebRtcPeer: {},
	    	remoteStreams: [],
	    	remoteCalledStream: null,
	    	usersInRoom: {},
	    	roomID: null,
    		socket: null,
				sockets: [],
    		recording: false,
    		atencionID: null,
    		deviceID: null,
    		calledUserID: null,
    		socketUrl: null,
    		socketRoom: null,
    		hideVideo: false,
    		silent: false,
    		readyForConnection: false,
    		alertID: null,
				geoUserAlert: null,
				setVideoFlowingTimeout: null,
				turnServer: null,
				loadingRemote: false,
				tryingConnection: true,
				connectionTimeout: null,
				timerConnectionInterval: 20,
				calledUserVideoReady: false
	    }
	  },
	  mounted(){
	  	this.deviceID = this.videoCallData.deviceID
			this.socketUrl = this.videoCallData.videocall.socket_url
			this.socketRoom = this.videoCallData.videocall.socket_room
			this.videocallID = this.videoCallData.videocall.complaint_id
			this.calledUserID = this.videoCallData.user_id
			this.fullView = this.videoCallData.fullView
			this.hideVideo = this.videoCallData.hideVideo
			this.silent = this.videoCallData.silent
      this.alertID = this.videoCallData.id
      this.geoUserAlert = this.videoCallData.geo_usuario
			this.createRoomAndStart()
			navigator.connection.onchange = this.changeHandler
	  },
	  methods: {
	  	changeHandler(event){
	  		console.log(event)
	  	},
	  	async createRoomAndStart(tries = 0){
/* 	  		if(!this.socketUrl || !this.socketRoom || !this.videocallID){
		      const room = await createVideoCallRoom()
		      if(room.code === 200){
		        const videocall = room.room
						this.socketUrl = videocall.socket_url
						this.socketRoom = videocall.socket_room
						this.videocallID = videocall.id

			      this.$store.commit("setVideoCallData", {
			        status: true,
			        alertID: this.alertID,
			        geoUserAlert: this.geoUserAlert,
			        fullView: this.fullView,
			        deviceID: this.deviceID,
			        calledUserID: this.calledUserID,
			        socketUrl: this.socketUrl,
			        socketRoom: this.socketRoom,
			        videocallID: this.videocallID,
			        hideVideo: this.hideVideo,
			        silent: this.silent,
			      })
		      }
		      else if(tries <= 3){
		      	this.createRoomAndStart(tries++)
		      }
		    } */
		    if(this.socketUrl && this.socketRoom && this.videocallID){
		    	this.readyForConnection = true
	    		this.startConnection()
	        // await initVideoCallWithDevice({
	        //   to_users: [ this.calledUserID ],
	        //   device_id: this.deviceID,
	        //   videocall_id: this.videocallID,
	        //   socket_room: this.socketRoom,
	        //   socket_url: this.socketUrl,
	        //   silent: this.silent,
	        //   hideVideo: this.hideVideo,
	        // })
	      }
	  	},
	  	goPicInPic() {
	  		this.fullView = false
	  	},
	  	goFullScreen(){
	  		this.fullView = true
	  	},
			setVideoFlowingCountDown(){
				this.setVideoFlowingTimeout = setTimeout(() => {
					this.reloadConnection()
				}, 7000);
			},
	  	async startConnection(){
		    this.socket = io(this.socketUrl,
			    {
			      transports: ['websocket'],
			      autoConnect: false,
			      reconnect: true,
			      forceNew: true
			    })
				this.setSocketListeners()
				this.startVideoCall()
				this.inProgress = true
				this.loadingRemote = true
	      //const atencion = await startAtencion({user_id: this.calledUserID})
/* 	      if(atencion.code === 200){
	        this.atencionID = atencion.atencion.id
	      } */
			},
			setSocketListeners(){
				this.socket.on('message', (data) => {
					// if(data.id !== 'roomStats' && data.id !== 'videoStats'){ console.log('Message from server', data) }
				  switch (data.id) {
				    case 'startResponse':
				      this.startResponse(data.sdpAnswer);
				      break;
				    case 'remoteResponse':
				      this.remoteResponse(data.remoteSocketID, data.sdpAnswer);
				      break;
				    case 'error':
				      console.log('Error message from server: ' + data.message);
				      break;
				    case 'iceCandidate':
				      this.localWebRtcPeer.addIceCandidate(data.candidate)
				      break;
				    case 'remoteIceCandidate':
				    	this.remotesWebRtcPeer[data.remoteSocketID].addIceCandidate(data.candidate)
				      break;
				    case 'usersInRoom':
				      this.createMultipleNewEndpoints(data.usersInRoom)
				      break;
				    case 'inRoomUserChange':
				      this.inRoomUserChange(data)
				      break;
				    case 'newUserInRoom':
				      this.addUserToRoom(data.user)
				      break;
				    case 'userLeaveRoom':
				      this.destroyConnectionWithRemote(data.socketID)
							this.endVideoCall()
				      break;
				    case 'startRecording':
				      this.recording = true
				      break;
				    case 'stopRecording':
				      this.recording = false
				      break;
				    case 'roomStats':
				      // this.handleRoomStats(data.stats)
				      break;
				    case 'videoStats':
				    	// console.log('videoStats', data.stats)
				      // handleVideoStats(data.stats)
				      break;
				    case 'mediaFlowStateChange':
				    	console.log('mediaFlowStateChange', data)
				      break;
				    case 'onVideoReady':
				      this.onVideoReady(data.socketID)
				      break;
				    default:
				      console.log('Unrecognized message: ', data);
			  	}
			  })
			},
			startVideoCall(){
				const name = this.$store.state.userData.name
				const userID = this.$store.state.userData.id
				this.join(this.socketRoom, name, userID, true)
			},
			endVideoCall(){
			  this.socket.close()
			  this.localWebRtcPeer && this.localWebRtcPeer.dispose()
			  Object.keys(this.remotesWebRtcPeer).forEach((key) => {
			    this.remotesWebRtcPeer[key] && this.remotesWebRtcPeer[key].dispose()
			  })
				if(this.atencionID){
					endAtencion({atencion_id: this.atencionID})
				}
				this.cleanRoom()
				this.deleteFromRTDB()
			},
			deleteFromRTDB(){
				this.videocallID
				firebase.database(this.$store.state.primaryDB).ref('/SOSclick/Denuncias/' + this.videocallID).remove()
			},
	  	hideRemoteVideo(socketID){
	  		const message = {
	  			id: 'admin-actionMessage',
	  			action: 'admin-ToggleVideo',
	  			to: socketID,
	  			status: false
	  		}
			  this.sendMessage(message)
	  	},
			cleanRoom(){
	    	this.fullView = true
	    	this.inProgress = false
	    	this.localWebRtcPeer = null
	    	this.localStream = null
	    	this.remotesWebRtcPeer = {}
	    	this.remoteStreams = []
	    	this.remoteCalledStream = null
	    	this.usersInRoom = {}
	    	this.roomID = null
    		this.socket = null
    		this.recording = false
    		this.atencionID = null
    		this.deviceID = null
    		this.calledUserID = null
    		this.socketUrl = null
    		this.socketRoom = null
    		this.hideVideo = false
    		this.readyForConnection = false
    		this.turnServer = null

				this.tryingConnection = false
				this.connectionTimeout && clearInterval(this.connectionTimeout)
				this.connectionTimeout = null
        this.$store.commit("setVideoCallData", {
		      status: false,
      		alertID: null,
          geoUserAlert: null,
		      fullView: true,
		      deviceID: null,
		      calledUserID: null,
		      socketUrl: null,
		      socketRoom: null,
		      videocallID: null,
		      hideVideo: false,
		      silent: false
		    })
				this.calledUserVideoReady = false
			},
			join(roomName, userName, userID, isAdmin, operatorCheck = true) {
			  this.socket.connect()
			  this.socket.emit('join', {roomName, userName, userID, isAdmin, operatorCheck}, response => {
			  	this.addUserToRoom(response, true)
			  	this.turnServer = {
			  		turn_ip: response.turn_ip,
						turn_port: response.turn_port,
						turn_user: response.turn_user,
						turn_password: response.turn_password,
					}
			  	this.startComunnications(userName)
			  })
			},
	  	startComunnications(userName) {
				this.connectionTimeout = setInterval(() => {
					this.timerConnectionInterval--
					if(this.timerConnectionInterval == 0){
						/* this.endVideoCall() */

					}
				}, 1000)

				const domVideoElement = document.getElementById('testsocketID')
			  var options = {
	    		remoteVideo: domVideoElement,
	    		onicecandidate: (candidate) => this.onIceCandidate(candidate),
			    configuration: {
			      iceServers: [{
			        "urls":"turn:" + this.turnServer.turn_ip + ":" + this.turnServer.turn_port,
			        "username":this.turnServer.turn_user,
			        "credential":this.turnServer.turn_password,
			      }]
			    }
			  }
			  const self = this
			  this.localWebRtcPeer = kurentoUtils.WebRtcPeer.WebRtcPeerRecvonly(options, function(error) {
			    if(error) return console.log(error)
			    this.generateOffer((error, offerSdp) => self.onOffer(error, offerSdp))
			  });
			},
			onAddLocalStream(){
				this.localStream = this.localWebRtcPeer.getLocalStream()
			},
			onOffer(error, offerSdp) {
			  if(error) return console.log("error: ", error);
			  const message = {
			    id : 'start',
			    sdpOffer : offerSdp
			  }
			  this.sendMessage(message)
			},
			sendMessage(message){
				this.socket.emit('message', message)
			},
			onIceCandidate(candidate) {
			  var message = {
			    id : 'onIceCandidate',
			    candidate : candidate
			  }
			  this.sendMessage(message)
			},
			startResponse(sdpAnswer) {
			  this.localWebRtcPeer.processAnswer(sdpAnswer)
			},
			remoteResponse(remoteSocketID, sdpAnswer) {
			  this.remotesWebRtcPeer[remoteSocketID].processAnswer(sdpAnswer)
			},
			addUserToRoom(user, local = false){
			  const usersInRoom = Object.assign({}, this.usersInRoom)
			  user.local = local
			  usersInRoom[user.socketID] = user
			  this.usersInRoom = usersInRoom
			},
			inRoomUserChange(user){
				const userInfo = user.user
			  let usersInRoom = Object.assign({}, this.usersInRoom)
			  if(usersInRoom[user.socketID]){
			  	usersInRoom[user.socketID] = Object.assign(usersInRoom[user.socketID], userInfo)
			  	this.usersInRoom = usersInRoom
			  }
				if(this.calledUserID === user.userID){
					this.remoteCalledStream = {
						...userInfo,
						...this.remoteCalledStream
					}
				}
			},
			createMultipleNewEndpoints(usersInRoom){
			  usersInRoom.map((user) => {
			    this.createNewEndpoint(user)
			  })
			},
			createNewEndpoint(user){
			  const {socketID} = user
			  var options = {
    			// remoteVideo: video,
			    configuration: {
			      iceServers: [{
			        "urls":"turn:" + this.turnServer.turn_ip + ":" + this.turnServer.turn_port,
			        "username":this.turnServer.turn_user,
			        "credential":this.turnServer.turn_password,
			      }]
			    },
			    onicecandidate: (candidate) => { this.onIceCandidateRemote(candidate, socketID) },
	    		onaddstream: (event) => { this.onAddRemoteStream(user) }
			  }
			  const self = this
			  this.addUserToRoom(user)
			  this.remotesWebRtcPeer[socketID] = kurentoUtils.WebRtcPeer.WebRtcPeerRecvonly(options, function(error) {
			    if(error) return false
			    this.generateOffer( (error, offer) => { self.onRemoteOffer(error, offer, socketID) } )
			  });
			},
			onAddRemoteStream(user){
				const remoteStream = this.remotesWebRtcPeer[user.socketID].getRemoteStream()
				if(this.calledUserID === user.userID){
					this.remoteCalledStream = {
						...user,
						...{ stream: remoteStream }
					}
					this.loadingRemote = false
					// this.calledUserVideoReady = this.remoteCalledStream.mediaFlowingOut
					// if(this.calledUserVideoReady){
					// 	this.playCalledUserVideo()
					// }
					this.connectionTimeout && clearInterval(this.connectionTimeout)
					this.connectionTimeout = null
				}
				else{
					let remoteStreams = [...this.remoteStreams]
					remoteStreams.push({
						...user,
						stream: remoteStream
					})
					this.remoteStreams = remoteStreams
				}
			},
			onVideoReady(socketID){
				if(this.usersInRoom[socketID]){
					this.createNewEndpoint(this.usersInRoom[socketID])
				}
			},
			playCalledUserVideo(){
				if(!this.loadingRemote){ return null }
				this.loadingRemote = false
			},
			onIceCandidateRemote(candidate, socketID) {
			  const message = {
			    id : 'onIceCandidateRemote',
			    socketID,
			    candidate : candidate
			  };
			  this.sendMessage(message)
			},
			onRemoteOffer(error, offerSdp, socketID) {
			  if(error) return false
			  const message = {
			    id : 'newRemoteOffer',
			    socketID,
			    sdpOffer : offerSdp
			  }
			  this.sendMessage(message)
			},
			destroyConnectionWithRemote(socketID){
				if(this.remotesWebRtcPeer[socketID]){
			  	this.remotesWebRtcPeer[socketID].dispose()
			  	delete this.remotesWebRtcPeer[socketID]
			  }
			  const remoteStreamIndex = this.remoteStreams.findIndex((item) => {
			  	return item.socketID = socketID
			  })
			  if(remoteStreamIndex !== -1){
					let remoteStreams = [...this.remoteStreams]
			  	remoteStreams.splice(remoteStreamIndex, 1)
					this.remoteStreams = remoteStreams
			  }
			  const userInfo = this.usersInRoom[socketID]
		  	delete this.usersInRoom[socketID]
				if(this.calledUserID === userInfo.userID){
					this.remoteCalledStream = null
				}
			},
			closePreview(){
				this.endVideoCall()
			},
			goToFullVideoCall(){
				const videocallData = {
					status: true,
					alertID: this.alertID,
					geoUserAlert: this.geoUserAlert,
					fullView: true,
					deviceID: this.deviceID,
					calledUserID: this.calledUserID,
					socketUrl: this.socketUrl,
					socketRoom: this.socketRoom,
					videocallID: this.videocallID,
					hideVideo: false,
					silent: true
				}
				this.$store.commit("setVideoCallData", videocallData)
			},
	  }
	}
</script>

<style scoped>
.multiple-video-container{
	background: #c7c7c7;
	margin-bottom: 30px;
}
</style>